<template>
    <v-container grid-list-xs fluid  @contextmenu.prevent="$refs.menuGo.open($event)">
        <v-row>
            <v-col cols="6" class="text-center">
                <label>
                    <h2>Top 5 most profitable terminals by net income</h2>
                </label>
                <Bar :chart-options="chartOptionsX" :chart-data="top" :chart-id="'bar-chart'" dataset-id-key="label" />
            </v-col>
            
            <v-col cols="6" class="text-center">
                <label>
                    <h2>Bottom 5 least profitable terminals by net income</h2>
                </label>
                <Bar :chart-options="chartOptionsX" :chart-data="bottom" :chart-id="'bar-chart'" dataset-id-key="label" />
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-center">
                <label>
                    <h2> All terminals by net income </h2>
                </label>
                <Bar :chart-options="chartOptions" :chart-data="general" :chart-id="'bar-chart'" dataset-id-key="label"></Bar>
            </v-col>
        </v-row>
        <v-dialog
            v-model="dialog"
            scrollable 
            fullscreen 
            persistent
            transition="dialog-transition"
        >
            <v-card>
                <shift_analysis  :dashboard="true" v-if="view == 1" 
                @close="dialog = false;"
                @drilldown="drilldown(2)"
                ></shift_analysis>
                <drill_down :dashboard="true" @close="view = 1;" v-if="view == 2" @drilldown="drilldown(3)"></drill_down>
                <transacting :dashboard="true" @close="view = 2;" v-if="view == 3"></transacting>
            </v-card>
        </v-dialog>
        
        <vue-context ref="menuGo" dense>
            <template slot-scope="selected">
                <v-list density="compact" dense >
                    <v-list-item dense @click="dialog = true">
                            <v-icon>mdi-google-analytics</v-icon>
                        <v-list-item-title v-text="'Show ShiftAnalysis'"></v-list-item-title>
                    </v-list-item>
                </v-list>
            </template>
        </vue-context>
    </v-container>
</template>

<script>
// import Dispatch from '@/components/Dispatch/Dispatch';
import shift_analysis from './../Analytics/ShiftAnalyticsDetails.vue';
import drill_down from './../Analytics/DrillDownLevel.vue';
import transacting from './../Analytics/AnalyticsTransacting.vue';
import axios from 'axios';
import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
import { Bar } from 'vue-chartjs/legacy';
import { Doughnut } from 'vue-chartjs/legacy'
import { Scatter } from 'vue-chartjs/legacy'
import VueContext from 'vue-context';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    ArcElement,
    BarElement,
} from 'chart.js';

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    BarElement,
    ArcElement
);
export default {
    props: ['year','order','typeBy'],
    components: {
        LineChart: LineChartGenerator,
        Bar,
        Doughnut,
        Scatter,
        shift_analysis,
        drill_down,
        transacting,
        VueContext
    },
    watch: {
        '$store.state.analytics.StartTime': function () {
            this.getDataDash();
        },
        
        '$store.state.analytics.EndTime': function () {
            this.getDataDash();
        },
        'typeBy': function () {
            this.getDataDash();
        },
        'order': function () {
            this.getDataDash();
        },
    },
    data: function () {
        return {
            view:1,
            dialog:false,
            top: [],
            bottom: [],
            general: [],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            },
            chartOptionsX: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y',
                scales: {
                    x: {
                        beginAtZero: true
                    }
                }
            }
        }
    },
    mounted() {
        this.getDataDash();
        this.$store.state.analytics.url = 'shift-analytics/terminal';
        this.$store.state.analytics.title = "View By Terminal";
    },
    methods: {
        drilldown(view){
            this.view = view;
        },
        getDataDash: function () {
            let str = this.$store;
            str.state.isLoading = true;
            const parms = {
                StartDate : this.$store.state.analytics.StartTime,
                EndDate : this.$store.state.analytics.EndTime,
                TypeBy: this.typeBy,
                OrderBy : this.order.id
            }
            axios
                .post('dashboard/terminal/dash',parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.top = this.dataBar(response.data['top'], 'Terminal', 'Net', 'Top Terminal');
                    this.bottom = this.dataBar(response.data['bottom'], 'Terminal', 'Net', 'Bottom Terminal');
                    this.general = this.dataBar(response.data['general'], 'Terminal', 'Net', 'All Terminal');
                    // const specifics = ['Revenue', 'OtherRev', 'Expenses', 'OtherExp'];
                    console.log(this.top, this.bottom, this.general);
                    str.state.isLoading = false;

                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        dataRegions(data) {
            console.log(data);
            const labels = data.map(x => {
                return x.PrincipalRegion;
            });
            const values = data.map(x => {
                return x.Net;
            });
            const colors = data.map(x => {
                console.log(x.PrincipalRegion);
                return this.getRandomColor();
            });
            const row = {
                labels: labels,
                datasets: [
                    {

                        backgroundColor: colors,
                        data: values
                    }
                ]
            }
            return row;
        },
        dataBar(data, label, value, title) {
            const labels = data.map(x => {
                return x[label];
            });
            const values = data.map(x => {
                return x[value];
            });

            const row = {
                labels: labels,
                datasets: [
                    {
                        data: values,
                        label: title,
                        backgroundColor: "#0D47A1",
                        fill: false
                    }
                ]
            }
            return row;
        },
        dataScatter(data){
          const rows = data.map(x => {
                return {
                    label: x.Terminal,
                    fill: false,
                    borderColor: '#f87979',
                    backgroundColor: '#f87979',
                    data:[
                        {
                            x: x.Expenses,
                            y: x.Revenue
                        }
                    ]
                }
            });
            const datasets = {  
              datasets : rows 
            } 
            return datasets;
            
        },
        specificRegions(data, cat) {
            var spcReg = [];
            cat.forEach(async spc => {
                const regions = await data.map(x => {
                    return x[spc];
                });
                const labels = await data.map(x => {
                    return x.PrincipalRegion;
                });
                const row = {
                    labels: labels,
                    datasets: [
                        {
                            data: regions,
                            label: spc,
                            backgroundColor: this.getRandomColor(),
                            fill: false
                        }
                    ]
                }
                spcReg.push(row);
            });
            console.log(spcReg);
            return spcReg;
        },
        getRandomColor() {
            return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
        }
    }
};
</script>
